import { useQuery } from '@tanstack/react-query';
import { getDashboard } from '../api/dashboard.api.ts';
import { useAuthStore } from '@/shared/hooks/useAuthStore.ts';

export const dashboardKeys = {
  all: ['dashboard'] as const,
};

export function useDashboard() {
  const accessToken = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: dashboardKeys.all,
    queryFn: getDashboard,
    refetchInterval: 30_000,
    enabled: !!accessToken,
  });
}
